import { render, staticRenderFns } from "./PopularityRanking.vue?vue&type=template&id=179d02d4&scoped=true&"
import script from "./PopularityRanking.vue?vue&type=script&lang=js&"
export * from "./PopularityRanking.vue?vue&type=script&lang=js&"
import style0 from "./PopularityRanking.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PopularityRanking.vue?vue&type=style&index=1&id=179d02d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d02d4",
  null
  
)

export default component.exports